import { PARTy } from 'src/app/component/auth/model/user.model';

export class Organization {
    ID?: number;
    PARTIES_ID?: number;
    NAME?: string;
    EMAIL_DOMAIN?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;

    PARTy?: PARTy;
}
